'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminTitresMinierController', ['$scope', '$http', '$timeout', 'FilterState', function($scope, $http, $timeout, FilterState) {

  var API = '/api/titres-miniers';

  var rawList = [];
  var allList = [];
  $scope.titres        = [];
  $scope.isLoading     = true;
  $scope.showModal     = false;
  $scope.saving        = false;
  $scope.currentPage   = 1;
  $scope.itemsPerPage  = 10;
  $scope.totalItems    = 0;
  $scope.totalPages    = 0;
  $scope.searchQuery     = '';
  $scope.filterType      = '';
  $scope.filterStatut    = '';
  $scope.filterDateDebut = '';
  $scope.filterDateFin   = '';
  $scope.editingItem   = {};
  $scope.successMsg    = '';
  $scope.errorMsg      = '';

  // ── Pagination ────────────────────────────────────────────────────────────
  function paginate() {
    var size = parseInt($scope.itemsPerPage, 10);
    if (!size) {
      $scope.titres     = allList;
      $scope.totalPages = 1;
    } else {
      var start = ($scope.currentPage - 1) * size;
      $scope.titres     = allList.slice(start, start + size);
      $scope.totalPages = Math.ceil(allList.length / size) || 1;
    }
  }

  $scope.changePageSize = function() { $scope.currentPage = 1; paginate(); };

  // ── Filtres ───────────────────────────────────────────────────────────────
  function parseDateField(d) {
    if (!d) return null;
    if (Array.isArray(d)) return new Date(d[0], d[1]-1, d[2]);
    var dt = new Date(d); return isNaN(dt.getTime()) ? null : dt;
  }
  function dateInRange(d, debut, fin) {
    if (!debut && !fin) return true;
    var dt = parseDateField(d);
    if (!dt) return !debut;
    if (debut && dt < new Date(debut)) return false;
    if (fin   && dt > new Date(fin + 'T23:59:59')) return false;
    return true;
  }
  function applyFilters() {
    var q  = ($scope.searchQuery  || '').toLowerCase().trim();
    var t  = ($scope.filterType   || '').trim();
    var s  = ($scope.filterStatut || '').trim();
    allList = rawList.filter(function(t_) {
      var matchQ = !q || [t_.societe || '', t_.numeroTitre || '', t_.substance || '']
        .some(function(f) { return f.toLowerCase().indexOf(q) !== -1; });
      var matchT = !t || t_.typeTitre === t;
      var matchS = !s || t_.statut === s;
      var matchD = dateInRange(t_.dateAttribution, $scope.filterDateDebut, $scope.filterDateFin);
      return matchQ && matchT && matchS && matchD;
    });
    $scope.totalItems  = allList.length;
    $scope.currentPage = 1;
    paginate();
  }
  function saveFilters() {
    FilterState.save('titres-miniers', { q: $scope.searchQuery, type: $scope.filterType, statut: $scope.filterStatut, debut: $scope.filterDateDebut, fin: $scope.filterDateFin });
  }
  (function() {
    var f = FilterState.load('titres-miniers');
    $scope.searchQuery     = f.q      || '';
    $scope.filterType      = f.type   || '';
    $scope.filterStatut    = f.statut || '';
    $scope.filterDateDebut = f.debut  || '';
    $scope.filterDateFin   = f.fin    || '';
  })();

  var searchTimeout;

  function flash(type, msg) {
    $scope[type] = msg;
    $timeout(function() { $scope[type] = ''; }, 3500);
  }

  // ── Chargement ────────────────────────────────────────────────────────────
  $scope.load = function() {
    $scope.isLoading = true;
    $http.get(API)
      .then(function(res) {
        rawList = Array.isArray(res.data) ? res.data : (res.data.content || []);
        applyFilters();
      })
      .catch(function() { flash('errorMsg', 'Erreur lors du chargement des titres miniers.'); })
      .finally(function() { $scope.isLoading = false; });
  };

  $scope.onSearch = function() {
    if (searchTimeout) $timeout.cancel(searchTimeout);
    searchTimeout = $timeout(function() { saveFilters(); applyFilters(); }, 300);
  };

  $scope.onFilterChange = function() { saveFilters(); applyFilters(); };
  $scope.onDateChange   = function() { saveFilters(); applyFilters(); };
  $scope.clearDates     = function() { $scope.filterDateDebut = ''; $scope.filterDateFin = ''; saveFilters(); applyFilters(); };

  $scope.setPage = function(p) {
    if (p < 1 || p > $scope.totalPages) return;
    $scope.currentPage = p; paginate();
  };

  $scope.getPages = function() {
    var pages = [], s = Math.max(1, $scope.currentPage - 2), e = Math.min($scope.totalPages, $scope.currentPage + 2);
    for (var i = s; i <= e; i++) pages.push(i);
    return pages;
  };

  // ── Formatage ─────────────────────────────────────────────────────────────
  $scope.formatDate = function(date) {
    if (!date) return '—';
    var d, day, month, year;
    if (Array.isArray(date)) {
      year = date[0]; month = date[1]; day = date[2];
    } else {
      d = new Date(date);
      if (isNaN(d.getTime())) return '—';
      day = d.getDate(); month = d.getMonth() + 1; year = d.getFullYear();
    }
    return (day < 10 ? '0' + day : '' + day) + '/' +
           (month < 10 ? '0' + month : '' + month) + '/' + year;
  };

  function toDateStr(date) {
    if (!date) return '';
    if (Array.isArray(date)) {
      var m = date[1] < 10 ? '0' + date[1] : '' + date[1];
      var d = date[2] < 10 ? '0' + date[2] : '' + date[2];
      return date[0] + '-' + m + '-' + d;
    }
    return date.substring(0, 10);
  }

  // ── Modal ─────────────────────────────────────────────────────────────────
  $scope.openModal = function(t) {
    if (t) {
      $scope.editingItem = angular.copy(t);
      $scope.editingItem.dateAttributionStr = toDateStr(t.dateAttribution);
      $scope.editingItem.dateExpirationStr  = toDateStr(t.dateExpiration);
    } else {
      $scope.editingItem = { statut: 'En vigueur', dateAttributionStr: '', dateExpirationStr: '' };
    }
    $scope.showModal = true;
  };

  $scope.closeModal = function() { $scope.showModal = false; $scope.editingItem = {}; };

  // ── Sauvegarde ────────────────────────────────────────────────────────────
  $scope.save = function() {
    if (!$scope.editingItem.societe) { flash('errorMsg', 'La société est obligatoire.'); return; }
    $scope.saving = true;
    var payload = angular.copy($scope.editingItem);
    payload.dateAttribution = payload.dateAttributionStr || null;
    payload.dateExpiration  = payload.dateExpirationStr  || null;
    delete payload.dateAttributionStr;
    delete payload.dateExpirationStr;

    var isEdit = !!payload.id;
    var req = isEdit ? $http.put(API + '/' + payload.id, payload) : $http.post(API, payload);
    req.then(function() {
      $scope.closeModal(); $scope.load();
      flash('successMsg', isEdit ? 'Titre minier mis à jour.' : 'Titre minier créé.');
    })
    .catch(function(err) {
      flash('errorMsg', (err.data && typeof err.data === 'string') ? err.data : 'Erreur lors de l\'enregistrement.');
    })
    .finally(function() { $scope.saving = false; });
  };

  // ── Suppression ───────────────────────────────────────────────────────────
  $scope.delete = function(t) {
    if (!confirm('Supprimer le titre minier de "' + t.societe + '" ?')) return;
    $http.delete(API + '/' + t.id)
      .then(function() { $scope.load(); flash('successMsg', 'Titre minier supprimé.'); })
      .catch(function() { flash('errorMsg', 'Erreur lors de la suppression.'); });
  };

  // ── Export ────────────────────────────────────────────────────────────────
  $scope.showExportMenu = false;
  $scope.toggleExportMenu = function($event) { $event.stopPropagation(); $scope.showExportMenu = !$scope.showExportMenu; };
  var _hideMenu = function() { $scope.$applyAsync(function() { $scope.showExportMenu = false; $scope.showColPicker = false; }); };
  document.addEventListener('click', _hideMenu);
  $scope.$on('$destroy', function() { document.removeEventListener('click', _hideMenu); });

  $scope.showColPicker = false;
  $scope.toggleColPicker = function($event) { $event.stopPropagation(); $scope.showColPicker = !$scope.showColPicker; $scope.showExportMenu = false; };
  $scope.col = { numero: true, type: true, substance: true, region: true, expiration: true, statut: true };
  var COL_DEFS = [
    { key: 'societe',    label: 'Société',          fn: function(t){ return t.societe||''; } },
    { key: 'numero',     label: 'N° titre',         fn: function(t){ return t.numeroTitre||''; } },
    { key: 'type',       label: 'Type de titre',    fn: function(t){ return t.typeTitre||''; } },
    { key: 'substance',  label: 'Substance',        fn: function(t){ return t.substance||''; } },
    { key: 'region',     label: 'Région',           fn: function(t){ return t.region||''; } },
    { key: 'expiration', label: 'Date d\'expiration', fn: function(t){ return $scope.formatDate(t.dateExpiration); } },
    { key: 'statut',     label: 'Statut',           fn: function(t){ return t.statut||''; } }
  ];
  function visibleDefs() { return COL_DEFS.filter(function(d){ return d.key === 'societe' || $scope.col[d.key]; }); }
  function getExportRows() {
    var defs = visibleDefs();
    return allList.map(function(t) { return defs.map(function(d){ return d.fn(t); }); });
  }
  function getExportHeaders() { return visibleDefs().map(function(d){ return d.label; }); }
  function escHtml(s) { return String(s||'').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;'); }
  function triggerDl(blob, name) {
    var url = URL.createObjectURL(blob), a = document.createElement('a');
    a.href = url; a.download = name; document.body.appendChild(a); a.click(); document.body.removeChild(a);
    $timeout(function() { URL.revokeObjectURL(url); }, 500);
  }
  $scope.exportCSV = function() {
    $scope.showExportMenu = false;
    var rows = getExportRows().map(function(r) { return r.map(function(v) { return '"'+String(v).replace(/"/g,'""')+'"'; }).join(';'); });
    triggerDl(new Blob(['\uFEFF'+getExportHeaders().join(';')+'\n'+rows.join('\n')], {type:'text/csv;charset=utf-8;'}), 'titres-miniers.csv');
  };
  $scope.exportExcel = function() {
    $scope.showExportMenu = false;
    var cell='border:1px solid #b0bec5;padding:6px 10px;font-size:11pt;font-family:Calibri,Arial,sans-serif;vertical-align:middle;', rows=getExportRows(), hdrs=getExportHeaders();
    var html='<html><head><meta charset="utf-8"/></head><body><table style="border-collapse:collapse">';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#0f2544;color:#fff;font-size:14pt;font-weight:bold;text-align:center;padding:12px;">Titres Miniers</td></tr>';
    html+='<tr><td colspan="'+hdrs.length+'" style="'+cell+'background:#e8edf5;color:#555;font-size:9pt;text-align:center;">Exporté le '+new Date().toLocaleDateString('fr-FR')+' — '+rows.length+' entrée(s)</td></tr>';
    html+='<tr>'+hdrs.map(function(h){return'<th style="'+cell+'background:#1e3a5f;color:#fff;font-weight:bold;">'+h+'</th>';}).join('')+'</tr>';
    rows.forEach(function(r,i){var bg=i%2===0?'#f0f4fa':'#fff';html+='<tr>'+r.map(function(v){return'<td style="'+cell+'background:'+bg+';">'+escHtml(v)+'</td>';}).join('')+'</tr>';});
    html+='</table></body></html>';
    triggerDl(new Blob(['\uFEFF'+html],{type:'application/vnd.ms-excel;charset=utf-8;'}), 'titres-miniers.xls');
  };

  $scope.load();
}]);
